import React from 'react';

import { regPlatformTheme } from '@/styles/regPlatformTheme';

import styled from '@emotion/styled';

import { OrganisationSwitcherWrapper } from './OrganisationSwitcherWrapper';
import { UserProfile } from './UserProfile';

export const TopLine = () => {
  return (
    <BackgroundLine>
      <FirstLineWrapper>
        <OrganisationSwitcherWrapper />
        <UserProfile />
      </FirstLineWrapper>
    </BackgroundLine>
  );
};

const BackgroundLine = styled.div`
  padding: 8px 0;
  background-color: ${regPlatformTheme.colors.lightBlue};
`;

const FirstLineWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  max-width: var(--max-content-width);
  margin: 0 auto;
`;
